export default __webpack_public_path__ + "static/bg-notes-a0a42cba38ee55a18118faab66ecfbcb.jpg";